import React, { useState } from 'react';
import { useDropdownData, DropdownType } from './hooks/useDropdownData';
import { getDropdownConfig } from './dropdownConfigs';
import { Select } from 'packages/radiant-react/select';
import { SelectOption } from 'packages/radiant-react/select/base-select';
import styles from './styles.module.scss';

interface GeneralizedDropdownProps {
  type: DropdownType;
  selectedValue?: string;
  onChange: (value: string) => void;
  liveboardId?: string;
  disabled?: boolean;
}

export interface DropdownOption {
  id: string;
  label: string;
  disabled?: boolean;
}

export interface DropdownConfig {
  id: string;
  placeholder: string;
  searchPlaceholder?: string;
  disabled?: boolean;
  shouldAutoFocusSearch?: boolean;
  dropdownWidth?: 'targetWidth' | 'defaultWidth' | 'minTargetWidth';
}

export const GeneralizedDropdown: React.FC<GeneralizedDropdownProps> = ({
  type,
  selectedValue,
  onChange,
  liveboardId,
  disabled = false,
}) => {
  const [searchPattern, setSearchPattern] = useState('');

  const { options, loading } = useDropdownData({
    type,
    searchPattern,
    liveboardId,
  });

  const config = getDropdownConfig(type, disabled);

  const handleSearchInput = (term: string) => {
    setSearchPattern(term);
  };

  const {
    id,
    placeholder,
    searchPlaceholder,
    shouldAutoFocusSearch = true,
    dropdownWidth = 'targetWidth',
  } = config;

  return (
    <Select.Dropdown
      id={id}
      isSearchEnabled
      searchPlaceholder={searchPlaceholder}
      selectedOptions={selectedValue ? [selectedValue] : []}
      optionsGroups={[{ options }]}
      loading={loading}
      dropdownWidth={dropdownWidth}
      disabled={disabled}
      placeholder={placeholder}
      onSearchInput={handleSearchInput}
      onChange={(data: SelectOption | SelectOption[]) => {
        const option = Array.isArray(data) ? data[0] : data;
        if (option && !option.disabled) {
          onChange(option.id);
        }
      }}
      classList={{ selectValue: styles.dropdownValue, selectHeadClass: styles.dropdownHeader }}
      shouldAutoFocusSearch={shouldAutoFocusSearch}
      aria-label={`Select ${placeholder}`}
    />
  );
};
